import { render, staticRenderFns } from "./marketing.vue?vue&type=template&id=92a1a624&scoped=true&lang=pug&"
import script from "./marketing.vue?vue&type=script&lang=js&"
export * from "./marketing.vue?vue&type=script&lang=js&"
import style0 from "./marketing.vue?vue&type=style&index=0&id=92a1a624&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a1a624",
  null
  
)

export default component.exports